import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function StatusPembelianBarang() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  
  const [dataPembelian, setDataPembelian] = useState([]);
  const [empDataPembelian, setEmpDataPembelian] = useState([]);
  const [listNoFaktur, setListNoFaktur] = useState([]);
  const [noFaktur, setNoFaktur] = useState([]);
  const [empData, setEmpData] = useState([]);


  // CONTROLLER

  const fetchDataPembelian = async (id) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/statusbelibarang/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.pinjaman;

        const listFaktur = [];
        data.forEach(e => {
          listFaktur.push({ label: e.notrxdetailbarang, value: e.notrxdetailbarang })
        });

        setListNoFaktur(listFaktur);
        setDataPembelian(data);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const fetchUserData = async (id) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/user/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.userData;       
        setEmpData(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const checkStatusPembelian = (nofaktur) => {

    let data = [];
    dataPembelian.forEach(e => {
      if(e.notrxdetailbarang == nofaktur) {
        data.push({
          trxdetailbarang: moment(e.trxdetailbarang).format("DD/MM/YYYY"),
          plafond: "Rp." + parseFloat(e.plafond).toLocaleString('id-ID'),
          sisapokok: "Rp." + parseFloat(e.plafond - (e.cicilan_ke * e.cpokok)).toLocaleString('id-ID'),
          cicilanke: e.cicilan_ke + " dari " + e.lama,
          cicilan: "Rp." + parseFloat(parseInt((e.plafond / e.lama) + e.jasa_bulan)).toLocaleString('id-ID'),
          status: e.status,
          created_at: moment(e.created_at).format("DD/MM/YYYY"),
        })
      }
    });
    
    setEmpDataPembelian(data[0]);
  }

  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchDataPembelian(user.id);
      fetchUserData(user.id);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Barang</Link> /{' '}
              <Link to='/barang/statusbelibarang' style={{ color: '#333' }}>Status Pembelian Barang</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Pembelian Barang Anggota</b></p>
                <p>Silahkan memilih no faktur, kemudian anda akan melihat status serta data pembelian barang anda. No faktur yang tersedia adalah pembelian barang yang masih aktif.</p>
              </div>
              {/* No Faktur */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Faktur
                </label>
                <Select
                  options={listNoFaktur}
                  defaultValue={listNoFaktur && noFaktur}
                  placeholder="Pilih no faktur"
                  onChange={e => {
                    setNoFaktur(e);
                    checkStatusPembelian(e.value);
                  }}
                />
              </div>

              {/* Tanggal Pengajuan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <input
                  value={empDataPembelian.created_at}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Tanggal Approved */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Approved
                </label>
                <input
                  value={empDataPembelian.status === undefined || empDataPembelian.status === "Diajukan" || empDataPembelian.status === "Disetujui Pembiayaan" || empDataPembelian.status === "Ditolak" ? "-- menunggu approved --" : empDataPembelian.trxdetailbarang}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Total Belanja */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Belanja
                </label>
                <input
                  defaultValue={empDataPembelian.plafond}
                  readOnly
                  className="form-control"
                />
              </div>

              {/* Sisa pokok belanja */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Sisa Pokok
                </label>
                <input
                  defaultValue={empDataPembelian.sisapokok}
                  readOnly
                  className="form-control"
                />
              </div>

              {/* Cicilan ke */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Ke
                </label>
                <input
                  defaultValue={empDataPembelian.cicilanke}
                  readOnly
                  className="form-control"
                />
              </div>

              {/* Besar cicilan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Cicilan per Bulan
                </label>
                <input
                  defaultValue={empDataPembelian.status === "Diajukan" || empDataPembelian.status === "Ditolak" || empDataPembelian.status === "Disetujui Pembiayaan" ? "-- menunggu approved --" : empDataPembelian.cicilan}
                  readOnly
                  className="form-control"
                />
              </div>

              {/* Status */}
              <div className='col-md-3'>
                <label className='form-label'>
                  Status:
                </label>
                <span className='badge' style={{backgroundColor: '#333'}}>{empDataPembelian.status}</span>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default StatusPembelianBarang;